// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"notfound-module--pageWrapper--1h4i5","contentWrapper":"notfound-module--contentWrapper--3mc51","logo":"notfound-module--logo--26KV3"};